import {Module} from 'vuex';
import {actions} from './actions';
import {mutations} from './mutations';
import {SearchState} from './types';
import {AdminusStore} from '@/store/types';


export const state: SearchState = {
    query: '',
    filteredNodes: {},
    namespacesList: [],
    filteredNames: [],
};

const namespaced: boolean = true;

export const search: Module<SearchState, AdminusStore> = {
    namespaced,
    state,
    actions,
    mutations,
};
